/* global axios */

export default {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/google_product_categories`);
  },
};
